var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-0c262aad"), n = n(), _popScopeId(), n); };
var _hoisted_1 = {
    key: 0,
    class: "e-input-group__prepend"
};
var _hoisted_2 = ["data-placeholder"];
var _hoisted_3 = ["id", "aria-label", "disabled", "inputmode", "max", "maxlength", "min", "name", "placeholder", "readonly", "tabindex"];
var _hoisted_4 = {
    key: 1,
    class: "e-input-group__append"
};
import { computed, nextTick, onMounted, ref, watch } from 'vue';
import toString from 'lodash/toString';
import EError from '@common/ui/EError/EError.vue';
export default /*#__PURE__*/ _defineComponent(__assign({
    inheritAttrs: false,
}, { __name: 'EInputNumber', props: /*#__PURE__*/ _mergeModels({
        name: {},
        emptyAllowed: { type: Boolean },
        size: { default: 'medium' },
        id: {},
        disabled: { type: Boolean },
        readonly: { type: Boolean },
        placeholder: {},
        theme: { default: 'default' },
        label: {},
        tabindex: {},
        min: {},
        max: {},
        maxlength: {},
        decimalNumbers: {},
        keyFilter: {},
        inputCenter: { type: Boolean, default: false },
        autoWidth: { type: Boolean, default: false },
        mask: {},
        clearOnFocus: { type: [Boolean, Object] },
        inputMode: { default: 'decimal' },
        hideError: { type: Boolean },
        position: {},
        rule: {},
        validateOnMount: { type: Boolean }
    }, {
        "modelValue": {},
        "modelModifiers": {},
    }), emits: /*#__PURE__*/ _mergeModels(["input", "change", "inputValid", "changeValid", "clear", "blur", "focus", "paste"], ["update:modelValue"]), setup: function (__props, _a) {
        var _this = this;
        var __emit = _a.emit;
        var props = __props;
        var emit = __emit;
        var valueModel = _useModel(__props, "modelValue");
        var inputRef = ref();
        var hovering = ref(false);
        var focused = ref(false);
        var isComposing = ref(false);
        var isErrored = ref(false);
        var inputSize = computed(function () { return props.size; });
        var inputTheme = computed(function () { return props.theme; });
        var inputDisabled = computed(function () { return props.disabled; });
        var localId = computed(function () { return props.id; });
        onMounted(function () {
            // valueModel.value = parseValue(valueModel.value);
            inputRef.value.value = toString(valueModel.value);
        });
        watch(valueModel, function (v) {
            // Делаем проверку, чтобы при изменении значения пользователем оно не перезаписывало само себя
            // Двойной парсинг первого аргумента нужен для того, чтобы очистить от ненужных символов
            // что появляются во время неполного ввода числа ("1." превращает в "1" для корректного сравнения)
            if (toString(parseFloat(inputRef.value.value)) !== toString(v)) {
                inputRef.value.value = toString(v);
            }
        });
        var parseValue = function (value) {
            // Заменяем запятую на точку
            if ((/,/).test(value)) {
                value = value.replaceAll(/,/g, '.');
            }
            var valueNumber = parseFloat(value);
            valueNumber = isNaN(valueNumber) ? props.min || 0 : valueNumber;
            if (props.decimalNumbers && props.decimalNumbers >= 0) {
                valueNumber = parseFloat(valueNumber.toFixed(props.decimalNumbers));
            }
            if (props.max !== undefined && valueNumber > props.max) {
                valueNumber = props.max;
            }
            if (props.min !== undefined && valueNumber < props.min) {
                valueNumber = props.min;
            }
            return valueNumber;
        };
        var handleClearOnFocus = function () {
            if (props.clearOnFocus) {
                if (typeof props.clearOnFocus === 'object') {
                    if (props.clearOnFocus.value + '' === inputRef.value.value) {
                        inputRef.value.value = '';
                    }
                }
                else {
                    inputRef.value.value = '';
                }
            }
        };
        // Сбрасываем значение при blur и валидируем в соотсетствии с параметрами
        var handleResetOnBlur = function () {
            if (!inputRef.value)
                return;
            inputRef.value.value = toString(valueModel.value);
            if (props.clearOnFocus && inputRef.value.value === '') {
                inputRef.value.value = toString(valueModel.value);
            }
        };
        var handleBlur = function (event) {
            focused.value = false;
            handleResetOnBlur();
            emit('blur', event);
        };
        var handleFocus = function (event) {
            focused.value = true;
            handleClearOnFocus();
            emit('focus', event);
        };
        var handleCompositionStart = function () {
            isComposing.value = true;
        };
        var handleCompositionUpdate = function () {
            isComposing.value = true;
        };
        var handleCompositionEnd = function (event) {
            if (isComposing.value) {
                isComposing.value = false;
                handleInput(event);
            }
        };
        var handleInput = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var newVal, isNegative, replacedVal, inputVal, parseVal;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // я хз зачем
                        if (isComposing.value) {
                            return [2 /*return*/];
                        }
                        newVal = event.target.value;
                        isNegative = newVal ? newVal[0] === '-' : false;
                        replacedVal = newVal
                            .replaceAll('-', '');
                        inputVal = isNegative ? '-' + replacedVal : replacedVal;
                        parseVal = parseValue(inputVal);
                        // RIP логика
                        valueModel.value = inputVal;
                        return [4 /*yield*/, nextTick()];
                    case 1:
                        _a.sent();
                        emit('input', parseVal);
                        if (!isErrored.value) {
                            emit('inputValid', parseVal);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var handleChange = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var newVal, parseVal;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        newVal = event.target.value;
                        parseVal = parseValue(newVal);
                        valueModel.value = parseVal;
                        return [4 /*yield*/, nextTick()];
                    case 1:
                        _a.sent();
                        emit('change', parseVal);
                        if (!isErrored.value) {
                            emit('changeValid', parseVal);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        var handleKeydown = function (e) { return __awaiter(_this, void 0, void 0, function () {
            var isAction, value;
            return __generator(this, function (_a) {
                isAction = e.ctrlKey || e.metaKey;
                // чтобы можно было копировать/выделять/вставлять
                if (!isAction) {
                    // Если пытается добавить что-то кроме цифр, точки или запятой - не даем этого сделать
                    if (e.key.length === 1 && !/[\d,.-]/.test(e.key)) {
                        e.preventDefault();
                    }
                    value = inputRef.value.value;
                    if (e.key === '-' && value.includes('-')) {
                        e.preventDefault();
                    }
                    if (e.key === '.' && value.includes('.')) {
                        e.preventDefault();
                    }
                }
                if (typeof props.keyFilter === 'function') {
                    return [2 /*return*/, props.keyFilter(e)];
                }
                return [2 /*return*/];
            });
        }); };
        var handelPaste = function (e) {
            emit('paste', e);
        };
        return function (_ctx, _cache) {
            var _directive_maska = _resolveDirective("maska");
            return (_openBlock(), _createBlock(EError, {
                "hide-error": _ctx.hideError,
                name: _ctx.name,
                position: _ctx.position,
                rule: _ctx.rule,
                "validate-on-mount": _ctx.validateOnMount,
                value: valueModel.value,
                onChangeErrorStatus: _cache[2] || (_cache[2] = function ($event) { return (isErrored.value = $event); })
            }, {
                default: _withCtx(function () { return [
                    _createElementVNode("div", {
                        class: _normalizeClass([[
                                _ctx.autoWidth ? 'e-input--autowidth' : '',
                                inputSize.value ? 'e-input--' + inputSize.value : '',
                                inputTheme.value ? 'e-input--' + inputTheme.value : '',
                                isErrored.value && 'e-input--error',
                                {
                                    'e-input--disabled': inputDisabled.value,
                                    'e-input--input-center': _ctx.inputCenter,
                                    'e-input-group': _ctx.$slots.prepend || _ctx.$slots.append,
                                    'e-input-group--append': _ctx.$slots.append,
                                    'e-input-group--prepend': _ctx.$slots.prepend
                                }
                            ], "flex border rounded-lg e-input"]),
                        onMouseenter: _cache[0] || (_cache[0] = function ($event) { return (hovering.value = true); }),
                        onMouseleave: _cache[1] || (_cache[1] = function ($event) { return (hovering.value = false); })
                    }, [
                        (_ctx.$slots.prepend)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _renderSlot(_ctx.$slots, "prepend")
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", {
                            ref: "inputInnerWrapper",
                            class: _normalizeClass([_ctx.autoWidth ? 'e-input__inner-wrapper--autowidth' : '', "e-input__inner-wrapper relative flex-grow flex flex-row items-center pl-4"]),
                            "data-placeholder": _ctx.placeholder
                        }, [
                            _withDirectives(_createElementVNode("input", _mergeProps(_ctx.$attrs, {
                                id: localId.value,
                                ref_key: "inputRef",
                                ref: inputRef,
                                "aria-label": _ctx.label,
                                disabled: inputDisabled.value,
                                inputmode: _ctx.inputMode,
                                max: _ctx.max,
                                maxlength: _ctx.maxlength,
                                min: _ctx.min,
                                name: _ctx.name,
                                placeholder: _ctx.placeholder,
                                readonly: _ctx.readonly,
                                tabindex: _ctx.tabindex,
                                autocomplete: "nope",
                                class: "e-input__innerblock h-full w-full focus:outline-none transition-colors bg-transparent border-transparent appearance-none relative",
                                pattern: "\\\\d*",
                                type: "text",
                                onBlur: handleBlur,
                                onChange: handleChange,
                                onCompositionend: handleCompositionEnd,
                                onCompositionstart: handleCompositionStart,
                                onCompositionupdate: handleCompositionUpdate,
                                onFocus: handleFocus,
                                onInput: handleInput,
                                onKeydown: handleKeydown,
                                onPaste: handelPaste
                            }), null, 16, _hoisted_3), [
                                [_directive_maska]
                            ])
                        ], 10, _hoisted_2),
                        (_ctx.$slots.append)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _renderSlot(_ctx.$slots, "append")
                            ]))
                            : _createCommentVNode("", true)
                    ], 34)
                ]; }),
                _: 3
            }, 8, ["hide-error", "name", "position", "rule", "validate-on-mount", "value"]));
        };
    } }));
